/*	Copyright (c) 1996 - 2026 NoWatt Ltd				*/
/*	  All Rights Reserved  											*/

import React, { useEffect } from 'react';

const Team = () => {
  useEffect(() => {
    const swiperCtor = window.Swiper;
    if (!swiperCtor || !document.getElementById('team')) return;

    const swiper = new swiperCtor('#team', {
      slidesPerView: 1,
      breakpoints: {
        450: { slidesPerView: 2 },
        1000: { slidesPerView: 4 }
      },
      pagination: { el: '#team .swiper-pagination', clickable: true }
    });

    return () => swiper.destroy?.(true, true);
  }, []);

  return (
    <div id="tf-team" className="text-center">
      <div className="overlay">
        <div className="container">
          <div className="section-title center">
            <h2><strong>Our team</strong></h2>
            <div className="line"><hr /></div>
          </div>
          <div id="team" className="swiper">
            <div className="swiper-wrapper">
              <div className="swiper-slide"><div className="thumbnail"><img className="rounded-circle team-img" src="img/team/paul.jpg" alt="Paul" /><div className="caption"><h3>Paul</h3><p>Hardware</p><p>Creating miracles in miniature for less.</p></div></div></div>
              <div className="swiper-slide"><div className="thumbnail"><img className="rounded-circle team-img" src="img/team/alli.jpg" alt="Allister" /><div className="caption"><h3>Allister</h3><p>Software</p><p>Developing algorithms that learn for themselves.</p></div></div></div>
              <div className="swiper-slide"><div className="thumbnail"><img className="rounded-circle team-img" src="img/team/anna.jpg" alt="Anna" /><div className="caption"><h3>Anna</h3><p>Sales</p><p>Doing everything, and keeping the lads in order!</p></div></div></div>
              <div className="swiper-slide"><div className="thumbnail"><img className="rounded-circle team-img" src="img/team/tugrul.jpg" alt="Tugrul" /><div className="caption"><h3>Tugrul</h3><p>Analyst</p><p>Seeker of wisdom and anomolies.</p></div></div></div>
              <div className="swiper-slide"><div className="thumbnail"><img className="rounded-circle team-img" src="img/team/jeremy.jpg" alt="Jeremy" /><div className="caption"><h3>Jeremy</h3><p>Marketing</p><p>Evangelist, communicator, and frustrated actor.</p></div></div></div>
              <div className="swiper-slide"><div className="thumbnail"><img className="rounded-circle team-img" src="img/team/mickie.jpg" alt="Mickie" /><div className="caption"><h3>Mickie</h3><p>Accounts</p><p>Accounting expert and chaser of expenses</p></div></div></div>
            </div>
            <div className="swiper-pagination" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Team;
